import api from '@/services/api';

// Zentraler Client: Basis-URL aus VUE_APP_API_BASE und Wartungsmodus-Erkennung wie bei allen anderen Aufrufen
export async function requestPasswordReset(email) {
    const res = await api.post('/password/forgot', { email });
    return res.data;
}

export async function resetPassword(token, password, passwordConfirm) {
    const res = await api.post('/password/reset', { token, password, passwordConfirm });
    return res.data;
}
